module.exports = "<span>\n    <img width=\"32\" class=\"framework-icon\" src=\"{{env.platforms[framework]?.icon}}\">\n     {{env.platforms[framework].name}}\n</span>"


//////////////////
// WEBPACK FOOTER
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/framework/framework.component.html
// module id = ../../../../../src/app/projects/shared/framework/framework.component.html
// module chunks = main